import { Model } from 'shared/services/api/models/Model'
import { NOTEPAD_PRODUCT_STOCK_STATUS } from 'shared/consts/marketplace'

import { NotepadProductOffer } from './notepadProductOffer'
import {
  Prices,
  PharmaForm,
  PackSize,
  NotepadProductV1,
  NotepadProductOfferV1
} from './notepadResponseTypes'
import { NotepadProductFlags } from './notepadProductFlags'

// Simple model from PIM product Model

export class NotepadProduct extends Model {
  canonicalUrl: string
  name: string
  discount: number
  flags: NotepadProductFlags
  images: string[]
  offers: NotepadProductOffer[]
  prices: Prices
  stockStatus: NOTEPAD_PRODUCT_STOCK_STATUS
  pharmaForm: PharmaForm
  upid: string
  orderLimit: number
  packageSize: PackSize

  constructor(src: NotepadProductV1) {
    super(src)
    this.canonicalUrl = src.canonicalUrl
    this.name = src.name
    this.discount = src.discount
    this.flags = src.flags ? new NotepadProductFlags(src.flags) : null
    this.images = src.images

    this.offers = Array.isArray(src.offers)
      ? src.offers.map(
          (offer: NotepadProductOfferV1) => new NotepadProductOffer(offer)
        )
      : []
    this.prices = src.prices
    this.stockStatus = src.stockStatus
    this.pharmaForm = src.pharmaForm
    this.upid = src.upid
    this.orderLimit = src.orderLimit
    this.packageSize = src.packageSize
  }
}
